import React, {useContext } from "react";
import { PJContext } from "./pj-context"
import {supFractions} from "../helpers";
import CONSTS from "./pj-constants";
import {PJJourneyNav} from "./pj-journey-nav";



function PJExistingCustomerCheck(props) {
    const { state, dispatch, data, animateFromCheckout } = useContext(PJContext);

    return  (
        <div className={"order-frame my-auto  journey-step " + props.current}>
            <div className="frame-content d-flex">
                <div className="my-auto mx-auto checkout">
                    <h4 className="center">CHECKOUT</h4>
                    <p className="center">Are you an existing REV customer?</p>
                    <div className="row cta">
                        <div className="col-6 my-auto text-right">
                            <div className="continue-button wp-block-button aligncenter is-style-outline has-white-background-color">
                                <button onClick={e => dispatch({ type: CONSTS.SET_STEP, args: {step: CONSTS.STEP_5b_PERSONAL_DETAILS, existingCustomer:false} })} className="wp-block-button__link has-text-color has-light-red-color has-white-background-color">No</button>
                            </div>
                        </div>

                        <div className="col-6 my-auto text-left">
                            <div className="continue-button wp-block-button aligncenter is-style-outline has-white-background-color">
                                <button onClick={e => dispatch({ type: CONSTS.SET_STEP, args: {step: CONSTS.STEP_6_ACCOUNT_DETAILS} })} className="wp-block-button__link has-text-color has-light-red-color has-white-background-color">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <PJJourneyNav backClick={e => {
                if ((state.selectedAddons !== undefined && //If addons selected
                    typeof state.selectedAddons === 'object' &&
                    Object.keys(state.selectedAddons).length !== 0)) {
                    //Showorder review
                    return dispatch({ type: CONSTS.SET_STEP, args: {step: CONSTS.STEP_2_ORDER_REVIEW} });
                } else {
                    //If no addons selected. Go back straigh to the beginning
                    return animateFromCheckout();
                }
            }} />
        </div>
    );
}

export { PJExistingCustomerCheck };